import {type Node, type Edge} from 'reactflow';

import {EntityMapEntityNodeOrInaccessibleInfoNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {LayoutSettings} from 'ui-library/reactflow/layout/calculateDimensionsForLayout';

// Border: 2px
// Padding: 16px
// Row-gap: 4px
// Icon: 28px
// Schema Name: 18px minimum when single line of text
// Schema Name: 36px maximum when two lines of text
// Total: 68px - 86px, assume the maximum
const DEFAULT_NODE_HEIGHT = 86;
// Max-width of EntityNode is 200px, so assume the maximum
const DEFAULT_NODE_WIDTH = 200;

/**
 * Default horizontal and vertical spacing for the entity map.
 */
export const DEFAULT_ENTITY_MAP_LAYOUT_SETTINGS: Partial<
  LayoutSettings<Node<EntityMapEntityNodeOrInaccessibleInfoNode>, Edge>
> = {
  calculateNodeDimensions: (node) => ({
    height: node.height ?? DEFAULT_NODE_HEIGHT,
    width: node.width ?? DEFAULT_NODE_WIDTH,
  }),
  horizontalSpaceBetweenNodes: 400,
  verticalSpaceBetweenNodes: 10,
};

/**
 * The limit of nodes that should be displayed in an entity map.
 *
 * We disable expanding the entity map from handles if the current total number of nodes exceeds this limit.
 * Note that this means that if we have a graph with ENTITY_MAP_TOTAL_NODE_LIMIT - 1 nodes, we're allowed to
 * further expand the entity map from handles, and get to a graph with as many as ENTITY_MAP_TOTAL_NODE_LIMIT
 * plus 30 nodes.
 */
export const ENTITY_MAP_TOTAL_NODE_LIMIT = 1000;
